import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { AllCommunityModule, ColDef, ICellRendererParams, ModuleRegistry } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { themeZafire } from '@zafire/ag-grid-enterprise';
import { ZfIcon, ZfPill, ZfTypography } from '@zafire/react';

ModuleRegistry.registerModules([AllCommunityModule]);

export interface WaiverRow {
  id: string;
  waiver: string;
  status: string;
}

const StatusCell = ({ value }: ICellRendererParams<WaiverRow, string>) => (
  <ZfPill variant="soft" color="success">
    <ZfIcon slot="leading" name="check_circle" size="medium" />
    {value}
  </ZfPill>
);

const NoWaiversOverlay = () => {
  const { t } = useTranslation();
  return (
    <ZfTypography variant="title-medium" color="muted">
      {t('pb.countryriskwaivers.grid.empty')}
    </ZfTypography>
  );
};

type Props = {
  rows: WaiverRow[];
  testId: string;
};

export const CountryRiskWaiversGrid = ({ rows, testId }: Props) => {
  const { t } = useTranslation();

  const columnDefs: ColDef<WaiverRow>[] = useMemo(
    () => [
      { headerName: t('pb.countryriskwaivers.grid.column.waiver'), field: 'waiver', flex: 1 },
      { headerName: t('pb.countryriskwaivers.grid.column.status'), field: 'status', flex: 1, cellRenderer: StatusCell },
    ],
    [t],
  );

  return (
    <div data-testid={testId}>
      <AgGridReact<WaiverRow>
        rowData={rows}
        columnDefs={columnDefs}
        getRowId={({ data }) => data.id}
        domLayout="autoHeight"
        suppressCellFocus
        noRowsOverlayComponent={NoWaiversOverlay}
        theme={themeZafire}
      />
    </div>
  );
};
